/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_AscInputs */

const en_sort_asc = /** @type {(inputs: Sort_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A → Z`)
};

const ko_sort_asc = /** @type {(inputs: Sort_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A → Z`)
};

const ja_sort_asc = /** @type {(inputs: Sort_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A → Z`)
};

/**
* | output |
* | --- |
* | "A → Z" |
*
* @param {Sort_AscInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sort_asc = /** @type {((inputs?: Sort_AscInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_AscInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sort_asc(inputs)
	if (locale === "ko") return ko_sort_asc(inputs)
	return ja_sort_asc(inputs)
});